import React, { createContext, useContext, useEffect, useState } from 'react';

export const WS_URL = process.env.REACT_APP_WS_URL;

// 1. Criar o Contexto
const WebSocketContext = createContext({
  unreadCount: { chamadosCount: 0, osCount: 0 }
});

// 2. Criar o Provedor (Componente que vai gerenciar a conexão)
export function WebSocketProvider({ children }) {
  const [unreadCount, setUnreadCount] = useState({ chamadosCount: 0, osCount: 0 });

  // eslint-disable-next-line array-callback-return
  useEffect(() => {
    // Roda UMA VEZ quando a aplicação carrega
    const usuarioLogado = JSON.parse(localStorage.getItem('userData'));
    // CORRIGIDO (handoff v2, item 2.1): o backend (websocket.js) agora exige
    // um JWT válido na mensagem de auth e busca o usuário real no banco —
    // não aceita mais um objeto "user" declarado livremente pelo cliente.
    // O token é o mesmo usado nas chamadas HTTP normais (ver createAuthHeaders
    // em api.js), guardado em localStorage sob a chave 'userToken'.
    const token = JSON.parse(localStorage.getItem('userToken'));

    // Se não tem usuário logado ou token, não conecta
    if (!usuarioLogado || !token) return () => {};

    // console.log("Conectando ao WebSocket...");
    const socket = new WebSocket(WS_URL);

    socket.onopen = () => {
      // console.log("WebSocket Conectado.");
      socket.send(JSON.stringify({ type: 'auth', token }));
    };

    socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      // console.log("WS Global Recebeu:", data);

      // Atualiza o estado global, mesclando os dados
      setUnreadCount(prevState => ({
        ...prevState,
        ...data
      }));
    };

    socket.onclose = (event) => {
      // console.log("WebSocket Desconectado.");
      // Código 4001 = o backend recusou a autenticação (token ausente,
      // inválido, ou usuário não encontrado/inativo). Não é um erro de rede.
      if (event.code === 4001) {
        console.warn('WebSocket: autenticação recusada pelo servidor —', event.reason);
      }
    };

    socket.onerror = (error) => {
      console.error("WebSocket Error:", error);
    };

    // Limpeza: fecha a conexão quando o App desmontar
    return () => {
      socket.close();
    };
  }, []); // Array vazio garante que rode só uma vez

  // O 'value' é o que será compartilhado com os componentes filhos
  const value = { unreadCount };

  return (
    <WebSocketContext.Provider value={value}>
      {children}
    </WebSocketContext.Provider>
  );
}

// 3. Criar um Hook customizado para facilitar o uso
export const useWebSocket = () => useContext(WebSocketContext);